import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightToBracket = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		style: { fill: "none" },
		fill: "none",
		d: "M9 1H11.6667C12.0203 1 12.3594 1.14048 12.6095 1.39052C12.8595 1.64057 13 1.97971 13 2.33333V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H9M5.66667 10.3333L9 7M9 7L5.66667 3.66667M9 7H1",
		stroke: "#808080",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRightToBracket;
